import SelectedArea from "./SelectedArea";

export default class AgentOutput {
    message: string;
    locationIds: number[];
    selectedAreas: SelectedArea[];

    constructor(message: string, locationIds: number[] = [], selectedAreas: SelectedArea[] = []) {
        this.message = message;
        this.locationIds = locationIds;
        this.selectedAreas = selectedAreas;
    }

    public totalAreas(): number {
        return this.selectedAreas.reduce((a, b) => new SelectedArea(a.areaCodes.concat(b.areaCodes))).areaCodes.length;
    }
}